import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { ENUM__image_asset_category } from '../ENUM__image_asset_category';
import { FIELD__base_visible_connectable } from '../_base/FIELD__base_connectable';
import { DECORATOR__ui_without_component } from '../_base/_decorators/DECORATOR__ui_without_component';
import { ENUM__field_graph_interaction } from '../_base/_enums/ENUM__field_graph_interaction';
import { ENUM__field_connectable_type } from '../_base/_methods/ENUM__field_connectable_type';
import { DECORATOR__field_not_linked } from '../_primitives/_base/DECORATOR__field_not_linked';
import { FIELD__tensor_image_mask_boolean } from '../_tensor/FIELD__tensor_image_mask_boolean';
import { FIELD__image_asset } from '../image/FIELD__image_asset';
import { FIELD_SD__conditioning } from './FIELD_SD__conditioning';

export class FIELD_SD__conditioning_masked extends FIELD__base_visible_connectable {
  /*
   * STATIC FIELDS
   */
  static _class_name_static = ENUM__dto_class_name.GRAPH_FIELD_SD__CONDITIONING_MASKED;

  /*
   * STATIC METHODS
   */

  /*
   * FIELDS
   */

  @FIELD_SD__conditioning.init_as_field({}, { graph__interaction: ENUM__field_graph_interaction.HIDDEN })
  conditioning!: FIELD_SD__conditioning;

  @FIELD__tensor_image_mask_boolean.init_as_field({}, { graph__interaction: ENUM__field_graph_interaction.HIDDEN })
  tensor_image__mask_boolean!: FIELD__tensor_image_mask_boolean;

  // todo: mb need change to image_asset_mask
  @FIELD__image_asset.init_as_field({ category: ENUM__image_asset_category.MASK }, { graph__interaction: ENUM__field_graph_interaction.HIDDEN })
  image__mask_boolean!: FIELD__image_asset;

  /*
   * PROPERTIES
   */

  field_connectable__value(graph: DTO_GRAPH__instance) {
    return this.meta.field_hash__value_full;
  }

  field_connectable__type() {
    return ENUM__field_connectable_type.CONDITIONING_SD_MASKED;
  }

  /*
   * EVENTS
   */

  /*
   * SYNC VALUE
   */

  /*
   * VALIDATION
   */

  @DECORATOR__ui_without_component
  post_init() {
    super.post_init();
  }

  /*
   * HASH
   */

  @DECORATOR__field_not_linked()
  has_effect_on_generation_runtime(graph: DTO_GRAPH__instance) {
    if (this.meta.kind__is_input) return false;

    return super.has_effect_on_generation_runtime(graph);
  }
}
